import { render } from "./ChampionAbilityIcon.vue?vue&type=template&id=316a1cd1&scoped=true"
import script from "./ChampionAbilityIcon.vue?vue&type=script&lang=ts"
export * from "./ChampionAbilityIcon.vue?vue&type=script&lang=ts"

import "./ChampionAbilityIcon.vue?vue&type=style&index=0&id=316a1cd1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-316a1cd1"

export default script